module.exports = __webpack_public_path__ + "img/certificate-2.3129e315.png";